import { gql } from '@apollo/client';

export const GET_PCA = gql`
  query GetArtistGenomePCA($axis: GenomeAxis!) {
    adminArtistGenomePCA(axis: $axis) {
      userId
      displayName
      avatarUrl
      x
      y
      sampleCount
      latitude
      longitude
    }
  }
`;

export const GET_NEIGHBORS = gql`
  query GetArtistGenomeNeighbors($userId: ID!, $axis: GenomeAxis!, $limit: Int) {
    adminArtistGenomeNeighbors(userId: $userId, axis: $axis, limit: $limit) {
      userId
      displayName
      avatarUrl
      similarity
      concordance
      latitude
      longitude
      city
      region
      country
      countryCode
      sampleCount
    }
  }
`;

export const GET_COMPARE = gql`
  query GetArtistGenomeCompare($userIdA: ID!, $userIdB: ID!) {
    adminArtistGenomeCompare(userIdA: $userIdA, userIdB: $userIdB) {
      artistA {
        userId
        displayName
        avatarUrl
        bio
        artistStatement
        city
        region
        country
        imageCount
        sampleImages
      }
      artistB {
        userId
        displayName
        avatarUrl
        bio
        artistStatement
        city
        region
        country
        imageCount
        sampleImages
      }
      visualSimilarity
      identitySimilarity
    }
  }
`;
